// src/components/msteams-link-user/DefaultMsTeamsLinkUser.tsx
import { useCallback } from "react";
import { useNovuUI } from "../../context/NovuUIContext.js";
import { Mounter } from "../Mounter.js";
import { jsx } from "react/jsx-runtime";
var DefaultMsTeamsLinkUser = (props) => {
  const {
    integrationIdentifier,
    connectionIdentifier,
    context,
    onLinkSuccess,
    onLinkError,
    onUnlinkSuccess,
    onUnlinkError,
    linkLabel,
    unlinkLabel
  } = props;
  const { novuUI } = useNovuUI();
  const mount = useCallback(
    (element) => {
      return novuUI.mountComponent({
        name: "MsTeamsLinkUser",
        props: {
          integrationIdentifier,
          connectionIdentifier,
          context,
          onLinkSuccess,
          onLinkError,
          onUnlinkSuccess,
          onUnlinkError,
          linkLabel,
          unlinkLabel
        },
        element
      });
    },
    [
      novuUI,
      integrationIdentifier,
      connectionIdentifier,
      context,
      onLinkSuccess,
      onLinkError,
      onUnlinkSuccess,
      onUnlinkError,
      linkLabel,
      unlinkLabel
    ]
  );
  return /* @__PURE__ */ jsx(Mounter, { mount });
};
export {
  DefaultMsTeamsLinkUser
};
//# sourceMappingURL=DefaultMsTeamsLinkUser.js.map